module.exports = __webpack_public_path__ + "img/main-defa.dd7979c.png";